const namespaced = true

const state = {}

const actions = {
    async getAllTiles({dispatch}) {
        return await dispatch('database/getItems', {table: 'tiles'}, {root: true})
    },

}
const mutations = {}
const getters = {}

export const tiles = {
    namespaced,
    state,
    getters,
    mutations,
    actions
}
